
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les outils numériques indispensables de l’homme à tout faire",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "À l’ère d’Internet et des smartphones, un homme à tout faire doit aussi se munir d’outils numériques pour garantir son excellente visibilité en ligne. Cet article vous livre des conseils et astuces à mettre en application dès à présent.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Les outils numériques indispensables de l’homme à tout faire",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "À l’ère d’Internet et des smartphones, un homme à tout faire doit aussi se munir d’outils numériques pour garantir son excellente visibilité en ligne. Cet article vous livre des conseils et astuces à mettre en application dès à présent.",
        },
      ],
    };
  },
};
